import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { environment } from '@env/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './app.footer.component.html',
})
export class AppFooterComponent {
    appName: string = '';

    constructor(public layoutService: LayoutService) {
        this.appName = environment.appName || 'Mi Comunidad';
    }
    get currentLogo(): string {
        return this.layoutService.getCurrentLogo();
    }
}
